import { c as _c } from "react-compiler-runtime";
import { createContext, useContext, useMemo, useState } from 'react';
import useCrmObjectTypeListingFilterState from 'framework-listing-lib/internal/hooks/useCrmObjectTypeListingFilterState';
import { jsx as _jsx } from "react/jsx-runtime";
const CrmObjectTypeListingContext = /*#__PURE__*/createContext(undefined);
export default function CrmObjectTypeListingClientProvider(t0) {
  "use memo";

  const $ = _c(33);
  const {
    associationSpecs,
    calendarProps,
    children,
    emptyStateFilter,
    fetcher,
    folderProps,
    hiddenFilter: hiddenFilterProp,
    initialFilter,
    inlineEditProps,
    quickFilterProps,
    searchInputProps
  } = t0;
  const [uncontrolledFolderId, setUncontrolledFolderId] = useState(undefined);
  let t1;
  if ($[0] !== folderProps || $[1] !== uncontrolledFolderId) {
    t1 = folderProps !== null && folderProps !== void 0 && folderProps.onSetCurrentFolderId ? {
      onSetCurrentFolderId: folderProps.onSetCurrentFolderId,
      currentFolderId: folderProps.currentFolderId
    } : {
      onSetCurrentFolderId: setUncontrolledFolderId,
      currentFolderId: uncontrolledFolderId
    };
    $[0] = folderProps;
    $[1] = uncontrolledFolderId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    onSetCurrentFolderId,
    currentFolderId
  } = t1;
  let t2;
  if ($[3] !== calendarProps || $[4] !== currentFolderId || $[5] !== hiddenFilterProp || $[6] !== initialFilter) {
    t2 = {
      calendarProps,
      hiddenFilter: hiddenFilterProp,
      initialFilter,
      folderId: currentFolderId
    };
    $[3] = calendarProps;
    $[4] = currentFolderId;
    $[5] = hiddenFilterProp;
    $[6] = initialFilter;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const {
    deletedObjects,
    filters,
    filterStateSource,
    hasPropertyFilter,
    hiddenFilter,
    isFilterFromCustomView,
    onSetDeletedObjects,
    onSetFilters
  } = useCrmObjectTypeListingFilterState(t2);
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const [expandableObjectIds, setExpandableObjectIds] = useState(t3);
  let t4;
  if ($[9] !== associationSpecs || $[10] !== calendarProps || $[11] !== currentFolderId || $[12] !== deletedObjects || $[13] !== emptyStateFilter || $[14] !== expandableObjectIds || $[15] !== fetcher || $[16] !== filterStateSource || $[17] !== filters || $[18] !== folderProps || $[19] !== hasPropertyFilter || $[20] !== hiddenFilter || $[21] !== initialFilter || $[22] !== inlineEditProps || $[23] !== isFilterFromCustomView || $[24] !== onSetCurrentFolderId || $[25] !== onSetDeletedObjects || $[26] !== onSetFilters || $[27] !== quickFilterProps || $[28] !== searchInputProps) {
    t4 = {
      associationSpecs,
      calendarProps,
      deletedObjects,
      emptyStateFilter,
      expandableObjectIds,
      fetcher,
      filters,
      filterStateSource,
      folderId: currentFolderId,
      folderProps,
      hasPropertyFilter,
      hiddenFilter,
      initialFilter,
      inlineEditProps,
      isFilterFromCustomView,
      onSetDeletedObjects,
      onSetExpandableObjectIds: setExpandableObjectIds,
      onSetFilters,
      onSetFolderId: onSetCurrentFolderId,
      quickFilterProps,
      searchInputProps
    };
    $[9] = associationSpecs;
    $[10] = calendarProps;
    $[11] = currentFolderId;
    $[12] = deletedObjects;
    $[13] = emptyStateFilter;
    $[14] = expandableObjectIds;
    $[15] = fetcher;
    $[16] = filterStateSource;
    $[17] = filters;
    $[18] = folderProps;
    $[19] = hasPropertyFilter;
    $[20] = hiddenFilter;
    $[21] = initialFilter;
    $[22] = inlineEditProps;
    $[23] = isFilterFromCustomView;
    $[24] = onSetCurrentFolderId;
    $[25] = onSetDeletedObjects;
    $[26] = onSetFilters;
    $[27] = quickFilterProps;
    $[28] = searchInputProps;
    $[29] = t4;
  } else {
    t4 = $[29];
  }
  const value = t4;
  let t5;
  if ($[30] !== children || $[31] !== value) {
    t5 = /*#__PURE__*/_jsx(CrmObjectTypeListingContext.Provider, {
      value: value,
      children: children
    });
    $[30] = children;
    $[31] = value;
    $[32] = t5;
  } else {
    t5 = $[32];
  }
  return t5;
}
export function useCrmObjectType() {
  "use memo";

  const context = useContext(CrmObjectTypeListingContext);
  if (context === undefined) {
    throw new Error("useCrmObjectType must be used within a CrmObjectTypeListingClientProvider");
  }
  return context;
}